import { getMainCarrier, getSentryCarrier } from '../carrier.js';
import { getStackAsyncContextStrategy } from './stackStrategy.js';
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */

function setAsyncContextStrategy(strategy) {
  // Get main carrier (global for every environment)
  var registry = getMainCarrier();
  var sentry = getSentryCarrier(registry);
  sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */


function getAsyncContextStrategy(carrier) {
  var sentry = getSentryCarrier(carrier);

  if (sentry.acs) {
    return sentry.acs;
  } // Otherwise, use the default one (stack)


  return getStackAsyncContextStrategy();
}

export { getAsyncContextStrategy, setAsyncContextStrategy };